<script setup lang="ts">
    import { ref } from 'vue';
    import { Head, Link, useForm, router } from '@inertiajs/vue3';
    import { User, Lock } from '@element-plus/icons-vue';
    import { ElMessage } from 'element-plus';
    import { route } from 'ziggy-js';
    import axios from "axios";

    defineProps({
    canResetPassword: {
    type: Boolean,
},
    status: {
    type: String,
},
});

    const form = useForm({
    email: '',
    password: '',
    remember: false,
});

    const loginFormRef = ref(null);

    const loginRules = {
    email: [
{ required: true, message: '请输入用户名', trigger: 'blur' },
{ type: 'string', message: '请输入正确的用户名', trigger: 'blur' }
    ],
    password: [
{ required: true, message: '请输入密码', trigger: 'blur' },
{ min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
    ]
};

    const submit = async () => {
    if (!loginFormRef.value) return;

    try {
        await loginFormRef.value.validate();
        form.post(route('login'), {
            onFinish: () => form.reset('password'),
            onSuccess: () => {
                ElMessage.success('登录成功');
                // router.visit(route('productSpace'));
            },
            onError: (errors) => {
                ElMessage.error(errors.message || '登录失败');
            }
        });
    } catch (error) {
        console.error('表单验证失败:', error);
    }
};
</script>



<style scoped>
.login-container {
    display: flex;
    height: 100vh;
    background-color: #f5f7fa;
}

.login-left {
    flex: 1;
    position: relative;
    overflow: hidden;
}

.tech-background {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #1a237e 0%, #0d47a1 100%);
    background-image: url("/images/cover.png");
    background-size: cover;  /* 图像覆盖整个元素，可能会被裁剪 */
    background-position: center;  /* 将图像居中 */
    position: relative;
}

.tech-background::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        linear-gradient(45deg, transparent 48%, rgba(255,255,255,0.1) 49%, rgba(255,255,255,0.1) 51%, transparent 52%),
        linear-gradient(-45deg, transparent 48%, rgba(255,255,255,0.1) 49%, rgba(255,255,255,0.1) 51%, transparent 52%);
    background-size: 30px 30px;
    opacity: 0.1;
}

.tech-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    width: 80%;
}

.welcome-text {
    font-size: 3rem;
    margin-bottom: 1rem;
    font-weight: 600;
    background: linear-gradient(45deg, #fff, #e3f2fd);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.sub-text {
    font-size: 1.2rem;
    opacity: 0.8;
}

.login-right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
}

.login-form-container {
    width: 100%;
    max-width: 400px;
    padding: 2rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.login-title {
    font-size: 1.8rem;
    color: #1a237e;
    margin-bottom: 0.5rem;
    text-align: center;
}

.login-subtitle {
    color: #666;
    text-align: center;
    margin-bottom: 2rem;
}

.login-form {
    margin-top: 2rem;
}

.form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.forget-link {
    color: #1a237e;
    text-decoration: none;
    font-size: 0.9rem;
}

.forget-link:hover {
    text-decoration: underline;
}

.login-button {
    width: 100%;
    height: 44px;
    font-size: 1rem;
    background: linear-gradient(45deg, #1a237e, #0d47a1);
    border: none;
    transition: transform 0.2s;
}

.login-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(26, 35, 126, 0.2);
}

:deep(.el-input__wrapper) {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

:deep(.el-input__wrapper:hover) {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

:deep(.el-input__wrapper.is-focus) {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
}

:deep(.el-input__inner:focus) {
    box-shadow: none !important;
}

:deep(.el-checkbox__label) {
    color: #666;
}
</style>

<template>
    <Head title="登录" />
    <div class="login-container">
        <!-- 左侧科技感背景 -->
        <div class="login-left">
            <div class="tech-background">
                <div class="tech-overlay">
                    <h1 class="welcome-text">智能赋能，引领未来</h1>
<!--                    <p class="sub-text">科技改变世界，创新引领未来</p>-->
                    <p class="sub-text">打造智能化业务新生态，释放 AI 无限潜能</p>
                </div>
            </div>
        </div>

        <!-- 右侧登录表单 -->
        <div class="login-right">
            <div class="login-form-container">
                <h2 class="login-title">系统登录</h2>
                <p class="login-subtitle">欢迎使用AI智能管理系统</p>

                <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                    {{ status }}
                </div>

                <el-form
                    ref="loginFormRef"
                    :model="form"
                    :rules="loginRules"
                    label-width="0"
                    size="large"
                    class="login-form"
                >
                    <el-form-item prop="email">
                        <el-input
                            v-model="form.email"
                            placeholder="用户名"
                            :prefix-icon="User"
                            autocomplete="username"
                        />
                    </el-form-item>

                    <el-form-item prop="password">
                        <el-input
                            v-model="form.password"
                            type="password"
                            placeholder="密码"
                            :prefix-icon="Lock"
                            autocomplete="current-password"
                            @keyup.enter="submit"
                        />
                    </el-form-item>

                    <div class="form-options">
                        <el-checkbox v-model="form.remember">记住我</el-checkbox>
                        <Link
                            v-if="canResetPassword"
                            :href="'/placeholder-url'"
                            class="forget-link"
                        >
                            忘记密码？
                        </Link>
                    </div>

                    <el-form-item>
                        <el-button
                            type="primary"
                            :loading="form.processing"
                            class="login-button"
                            @click="submit"
                        >
                            登录
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <footer class="icp-footer">
                <a
                    href="https://beian.miit.gov.cn/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    苏ICP备17009900号
                </a>
            </footer>
        </div>
    </div>
</template>

<style scoped>
.login-container {
    display: flex;
    height: 100vh;
    background-color: #f5f7fa;
}

.login-left {
    flex: 1;
    position: relative;
    overflow: hidden;
}

.tech-background {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #1a237e 0%, #0d47a1 100%);
    background-image: url("/images/cover.png");
    background-size: cover;  /* 图像覆盖整个元素，可能会被裁剪 */
    background-position: center;  /* 将图像居中 */
    position: relative;
}

.tech-background::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        linear-gradient(45deg, transparent 48%, rgba(255,255,255,0.1) 49%, rgba(255,255,255,0.1) 51%, transparent 52%),
        linear-gradient(-45deg, transparent 48%, rgba(255,255,255,0.1) 49%, rgba(255,255,255,0.1) 51%, transparent 52%);
    background-size: 30px 30px;
    opacity: 0.1;
}

.tech-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    width: 80%;
}

.welcome-text {
    font-size: 3rem;
    margin-bottom: 1rem;
    font-weight: 600;
    background: linear-gradient(45deg, #fff, #e3f2fd);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.sub-text {
    font-size: 1.2rem;
    opacity: 0.8;
}

.login-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
}

.icp-footer {
    margin-top: 18px;
    text-align: center;
    font-size: 13px;
}

.icp-footer a {
    color: #909399;
    text-decoration: none;
}

.icp-footer a:hover {
    color: #1a237e;
    text-decoration: underline;
}

.login-form-container {
    width: 100%;
    max-width: 400px;
    padding: 2rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.login-title {
    font-size: 1.8rem;
    color: #1a237e;
    margin-bottom: 0.5rem;
    text-align: center;
}

.login-subtitle {
    color: #666;
    text-align: center;
    margin-bottom: 2rem;
}

.login-form {
    margin-top: 2rem;
}

.form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.forget-link {
    color: #1a237e;
    text-decoration: none;
    font-size: 0.9rem;
}

.forget-link:hover {
    text-decoration: underline;
}

.login-button {
    width: 100%;
    height: 44px;
    font-size: 1rem;
    background: linear-gradient(45deg, #1a237e, #0d47a1);
    border: none;
    transition: transform 0.2s;
}

.login-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(26, 35, 126, 0.2);
}

:deep(.el-input__wrapper) {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

:deep(.el-input__wrapper:hover) {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

:deep(.el-input__wrapper.is-focus) {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
}

:deep(.el-input__inner:focus) {
    box-shadow: none !important;
}

:deep(.el-checkbox__label) {
    color: #666;
}
</style>
